// removed by extract-text-webpack-plugin
module.exports = {"itemone":"src-components-food----Menu-module---itemone---2CrNZ","itemtwo":"src-components-food----Menu-module---itemtwo---3cqSk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/food/Menu.module.css
// module id = 403
// module chunks = 32548347793320